import { render, staticRenderFns } from "./participantes.vue?vue&type=template&id=6eec5b92&"
import script from "./participantes.component.ts?vue&type=script&lang=ts&"
export * from "./participantes.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports